import { css } from "@emotion/react"
import React, { type ElementType } from "react"
import type { SpaceToken } from "../tokens"
import { cssVariables, tokenVar } from "../theme"
import type { PolymorphicProps } from "./polymorphic"

type StackAlignment = "stretch" | "start" | "center" | "end" | "baseline"
type StackJustification =
  "start" | "center" | "end" | "space-between" | "space-around" | "space-evenly"

interface StackOwnProps {
  readonly gap?: SpaceToken
  readonly align?: StackAlignment
  readonly justify?: StackJustification
}

export type StackProps<Component extends ElementType = "div"> =
  PolymorphicProps<Component, StackOwnProps>

const stackStyles = css`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const Stack = <Component extends ElementType = "div">({
  as,
  gap = "lg",
  align = "stretch",
  justify = "start",
  css: cssProp,
  ...props
}: StackProps<Component>) => {
  const Element = as ?? "div"

  return (
    <Element
      css={[
        stackStyles,
        css`
          gap: ${tokenVar(cssVariables.space[gap])};
          align-items: ${align};
          justify-content: ${justify};
        `,
        cssProp,
      ]}
      {...props}
    />
  )
}
